import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpsertSiteDailyReportMutation } from '../../../../hooks/mutations/useSiteDailyReportMutation';
import { SiteDailyReport } from '../../../../services/apiSLTP/dailyReports/siteDailyReports';
import CustomTextInput from '../../../ui/CustomTextInput';
import ModalBody, { ModalProps } from '../../ModalBody';

interface ManageValidationDailyObservationsModalProps extends ModalProps {
    refetch: () => void;
    siteDailyReport?: SiteDailyReport | null;
    siteName?: string;
    date?: string;
    siteId?: string;
}

const ManageValidationDailyObservationsModal: React.FC<ManageValidationDailyObservationsModalProps> = ({
    open,
    handleClose,
    refetch,
    siteDailyReport,
    siteName,
    date,
    siteId,
}) => {
    const { t } = useTranslation();

    const [globalObservations, setGlobalObservations] = useState(siteDailyReport?.globalObservations || '');

    const { mutate: upsertSiteDailyReport } = useUpsertSiteDailyReportMutation({
        onSuccess: () => {
            refetch();
            handleClose();
        },
    });

    return (
        <ModalBody
            title={t('observations')}
            subtitle={t('update')}
            description={siteName}
            open={open}
            handleClose={handleClose}
            onSubmit={() => {
                upsertSiteDailyReport({
                    date: siteDailyReport?.date || date || '',
                    siteId: siteDailyReport?.siteId._id || siteId || '',
                    globalObservations: globalObservations,
                });
            }}
            disableSubmit={globalObservations.trim() === siteDailyReport?.globalObservations?.trim()}
        >
            <CustomTextInput value={globalObservations} onChange={setGlobalObservations} label={`${t('')}`} multiline />
        </ModalBody>
    );
};

export default ManageValidationDailyObservationsModal;
